import { render, staticRenderFns } from "./dividers.vue?vue&type=template&id=4b30ef9b&scoped=true"
import script from "./dividers.vue?vue&type=script&lang=js"
export * from "./dividers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b30ef9b",
  null
  
)

export default component.exports